import { render, staticRenderFns } from "./a-logo.vue?vue&type=template&id=3826a7be&"
import script from "./a-logo.vue?vue&type=script&lang=js&"
export * from "./a-logo.vue?vue&type=script&lang=js&"
import style0 from "./a-logo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports